import { render, staticRenderFns } from "./SideBarDesktop.vue?vue&type=template&id=6e83b413&scoped=true"
import script from "./SideBarDesktop.vue?vue&type=script&lang=js"
export * from "./SideBarDesktop.vue?vue&type=script&lang=js"
import style0 from "./SideBarDesktop.vue?vue&type=style&index=0&id=6e83b413&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e83b413",
  null
  
)

export default component.exports